import { provide, inject } from 'vue';

export interface IBlockLabels {
    [key: string]: string
};

export enum ScopedBlockLabels {
    Default = 'Default',
    ClaimFormTile = 'ClaimFormTileModel',
    GiftPackagingTile = 'GiftPackagingTileModel',
}

const blockLabelsScopePrefix: string = 'BlockLabels';

export function isScopedBlockLabels(contentType: string) {
    const scopedBlocks: string[] = Object.values(ScopedBlockLabels);
    return scopedBlocks.indexOf(contentType) > -1;
}

export function provideBlockLabels(blockLabels: IBlockLabels, contentType?: string): void {
    const scope = contentType && isScopedBlockLabels(contentType) ? contentType : ScopedBlockLabels.Default;
    provide<IBlockLabels>(blockLabelsScopePrefix + scope, blockLabels);
}

export function useBlockLabels(LabelsScope: ScopedBlockLabels = ScopedBlockLabels.Default): IBlockLabels {
    const blockLabels = inject<IBlockLabels>(blockLabelsScopePrefix + LabelsScope);
    if (!blockLabels) {
        throw new Error(`No IBlockLabels provided for ${LabelsScope}`);
    }
    return blockLabels;
}
